import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=610d7c3e&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&id=610d7c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d7c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610d7c3e')) {
      api.createRecord('610d7c3e', component.options)
    } else {
      api.reload('610d7c3e', component.options)
    }
    module.hot.accept("./Join.vue?vue&type=template&id=610d7c3e&scoped=true&", function () {
      api.rerender('610d7c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/Join.vue"
export default component.exports